import { ThunkDispatch } from 'redux-thunk'
import { resetNoteState } from 'utils/actions/notes'
import { getShipment } from 'utils/actions/shipment'
import { closeDialog } from 'utils/actions/ui'
import { ENDPOINTS } from 'utils/api/callApi'
import { ICoverRequestData, ICoverDriverRequestData, IAssignDriverFields } from 'apps/booking/types'
import { clearCarrier } from 'apps/booking/utils/actions/carrier'
import { clearCompliance } from 'apps/booking/utils/actions/options'
import { IStore } from 'apps/booking/utils/reducers'
import {
  selectCoverLoadSuccess,
  selectCoverLoadError,
} from 'apps/booking/utils/selectors/coverLoad'
import { activeRowIdSelector } from 'apps/booking/utils/selectors/sidebar'

export enum COVER_LOAD_ACTION_TYPES {
  CREATE_COVER_REQUEST = 'CREATE_COVER_REQUEST',
  CREATE_COVER_SUCCESS = 'CREATE_COVER_SUCCESS',
  CREATE_COVER_FAILURE = 'CREATE_COVER_FAILURE',
  UPDATE_COVER_REQUEST = 'UPDATE_COVER_REQUEST',
  UPDATE_COVER_SUCCESS = 'UPDATE_COVER_SUCCESS',
  UPDATE_COVER_FAILURE = 'UPDATE_COVER_FAILURE',
  CLEAR_COVER_LOAD_ERROR = 'CLEAR_COVER_LOAD_ERROR',
  CLEAR_COVER_LOAD_DATA = 'CLEAR_COVER_LOAD_DATA',
}

const filterCoverLoadActionsByPrefix = (prefix: string) =>
  Object.keys(COVER_LOAD_ACTION_TYPES).filter((str: string) => str.startsWith(prefix))

export const saveCarrierToCover = (payload: ICoverRequestData, shipmentId?: number) => ({
  payload: {
    callApi: true,
    actionTypes: filterCoverLoadActionsByPrefix('CREATE'),
    requestData: {
      method: 'POST',
      group: 'cover',
      endpoint: ENDPOINTS.shipments,
      id: shipmentId,
      body: {
        shipment: {
          coveredBid: payload,
        },
      },
    },
  },
})

export const saveDriverToCover = (fields: IAssignDriverFields, shipmentId?: number) => {
  const driver = fields.selectedDriver || fields.newDriver
  const formattedPayload: ICoverDriverRequestData = {
    coveredBid: {
      driver,
      carrierAvailableTruck: {
        truckLocationCity: fields.truckLocation.city,
        truckLocationStateCode: fields.truckLocation.state,
        vin: fields.vin,
        truckNumber: fields.truckNumber,
      },
      ...(fields?.carrierContactName && {
        carrierContactName: fields.carrierContactName,
        carrierContactPhone: fields.carrierContactPhone,
        carrierContactPhoneExt: fields.carrierContactPhoneExt,
      }),
    },
    firstPickup: {
      manualEta: fields.manualEta,
      lateReason: fields.lateReason,
    },
  }

  return {
    payload: {
      callApi: true,
      actionTypes: filterCoverLoadActionsByPrefix('UPDATE'),
      requestData: {
        method: 'PUT',
        group: 'cover',
        endpoint: ENDPOINTS.shipments,
        id: shipmentId,
        body: {
          shipment: formattedPayload,
        },
      },
    },
  }
}

export const clearCoverloadError = () => ({
  type: COVER_LOAD_ACTION_TYPES.CLEAR_COVER_LOAD_ERROR,
})

export const clearCoverLoadData = () => ({
  type: COVER_LOAD_ACTION_TYPES.CLEAR_COVER_LOAD_DATA,
})

export const clearCoverLoadModal = (isSubmitted: boolean) => (
  dispatch: ThunkDispatch<IStore, any, any>,
  getState: () => IStore
) => {
  dispatch(closeDialog())

  const state = getState()
  const { activeRowId: shipmentId } = activeRowIdSelector(state)
  const hasFormSubmitSuccess = isSubmitted || selectCoverLoadSuccess(state)
  if (shipmentId && hasFormSubmitSuccess) {
    dispatch(clearCoverLoadData())
    dispatch(getShipment(shipmentId)) // Get updated shipment data
  }

  if (selectCoverLoadError(state)) {
    dispatch(clearCoverloadError())
  }

  dispatch(clearCarrier())
  dispatch(clearCompliance())
  dispatch(resetNoteState())
}
